import { loading, isConnected, isAuthorized, hasPropertyId } from '../state';
import services from '../../../services';
import { fetchAnalyticsData } from './fetchAnalyticsData';

/**
 * Google entegrasyon ve mülk bağlantı durumunu kontrol et
 * @param {string} assetId - Asset ID
 */
export async function checkPropertyLinked(assetId) {
  loading.value = true;
  
  try {
    // Google entegrasyon durumunu kontrol et
    const authResult = await services.analytics.checkGoogleAuth(assetId);
    
    // Google entegrasyon durumunu güncelle
    isConnected.value = authResult.isConnected;
    isAuthorized.value = authResult.isConnected;
    
    // Eğer entegrasyon varsa mülk bağlantısını kontrol et
    if (isConnected.value) {
      const propertyResult = await services.analytics.checkPropertyLinked(assetId);
      
      // Mülk bağlantı durumunu güncelle
      hasPropertyId.value = propertyResult.isLinked;
      
      // Eğer mülk bağlı ise analitik verilerini getir
      if (hasPropertyId.value) {
        await fetchAnalyticsData(assetId);
      }
      
      return propertyResult.isLinked;
    }
    
    return false;
  } catch (error) {
    // Hata durumunu sessizce işle ve state'i güncelle
    isConnected.value = false;
    isAuthorized.value = false;
    hasPropertyId.value = false;
    return false;
  } finally {
    loading.value = false;
  }
}